const apiConfig = {
    apiUrl: "https://api.varahiinfra.co/api/v1"
    // apiUrl: "http://localhost:5656/api/v1"
};

export default apiConfig;